import { type FunctionComponent, Suspense } from 'react';

import { useLazyComponent } from '@trello/use-lazy-component';

import { type DiscoveryAdNewUserNudgeProps } from './DiscoveryAdNewUserNudge';
export const LazyDiscoveryAdNewUserNudge: FunctionComponent<
  DiscoveryAdNewUserNudgeProps
> = (props) => {
  const NewUserNudge = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "discovery-ad-new-user-nudge-container" */ './DiscoveryAdNewUserNudgeContainer'
      ),
    { namedImport: 'DiscoveryAdNewUserNudgeContainer' },
  );

  return (
    <Suspense fallback={null}>
      <NewUserNudge {...props} />
    </Suspense>
  );
};
